//# sourceMappingURL=line.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/line.interface.js
// module id = 1196
// module chunks = 4